import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

export default function SectionDescription({ children, ...props }) {
  return (
    <Typography color="#001b35" variant="body1" {...props}>
      {children}
    </Typography>
  );
}

SectionDescription.propTypes = {
  children: PropTypes.node.isRequired,
};
